import api from './client';

// ─── 本机同步代理（E2EE 多端增量同步） ─────────────────────────────────────────
// 本地后端 /api/v1/sync/agent/*，不走 cloud-proxy。
// 同步口令仅在 unlock 时提交给本机后端用于派生密钥，不离开本机。

export interface SyncAgentStatus {
  unlocked: boolean;
  device_id: string | null;
  device_name: string | null;
  pending_ops: number;
  op_cursor: number;
  last_sync_at: string | null;
  last_error: string | null;
  auto_sync: boolean;
  /** 云端下拉通道（明文单向：云端主库 → 本机）开关，默认开。 */
  down_sync_enabled: boolean;
  /** 最近一次云端下拉完成时间（ISO），未拉过为 null。 */
  last_down_sync_at: string | null;
}

export const syncAgentApi = {
  /** 用同步口令解锁本机同步代理（启用自动同步）；口令错误返回 400/401。 */
  unlock: (password: string) =>
    api.post<{ success: boolean; device_id: string }>('/api/v1/sync/agent/unlock', { password }).then((r) => r.data),

  /** 查询本机同步代理状态。 */
  status: () => api.get<SyncAgentStatus>('/api/v1/sync/agent/status').then((r) => r.data),

  /** 立即执行一次增量同步（推送 + 拉取）。 */
  syncNow: () => api.post<{ success: boolean; pushed: number; pulled: number }>('/api/v1/sync/agent/now').then((r) => r.data),
};
